import React from "react";
import ata from "assets/images/ata.png";
import iso from "assets/images/iso.png";
import ATA from "assets/images/new-homepage-assets/accreditation icons/ata.png";
import ISO from "assets/images/new-homepage-assets/accreditation icons/iso.png";
import ISO2 from "assets/new-assets/ISO_2007.svg";
import ISO3 from "assets/new-assets/ISO_17100.svg";

export default function TranslationServices({ backgroundCol, styleOne }) {
  return (
    <section
      className={`${backgroundCol ? backgroundCol : "bg-darkBlue"} py-24`}
    >
      {styleOne == "1" ? (
        <div className=" px-4 flex items-center justify-center flex-col gap-y-10">
          <h2 className="text-gray text-3xl md:text-[35px] text-center font-secondary font-semibold sm:w-[723px] leading-relaxed">
            <span className="text-orange">ISO Certifications </span> for
            Enhanced Translation Quality
          </h2>
          <ul className="w-auto gap-x-8 flex lg:flex-row flex-col justify-between items-center lg:relative pt-6 lg:pt-0">
            <li className="logos flex flex-col items-center w-[186px] pt-6 lg:pt-0">
              <img src={ISO} alt="" className="lg:pb-12" />
              <div className=" lg:absolute lg:top-[6rem] w-[186px]">
                <p className="text-[14px] text-[white] pt-4  text-center">
                  ISO 9001:2015{" "}
                </p>
                <p className="text-[14px] text-[#AAAAAA] text-center">
                  Quality Management Systems
                </p>
              </div>
            </li>
            <li className="logos flex flex-col items-center w-[186px] pt-6 lg:pt-0">
              <img src={ISO2} alt="" className="lg:pb-12" />
              <div className=" lg:absolute lg:top-[6rem] w-[186px]">
                <p className="text-[14px] text-[white] pt-4  text-center">
                  ISO 18587:2017{" "}
                </p>
                <p className="text-[14px] text-[#AAAAAA] text-center">
                  Post-editing Machine Translation Output
                </p>
              </div>
            </li>
            <li className="logos flex flex-col items-center w-[186px] pt-6 lg:pt-0 sm:pb-0 pb-4">
              <img src={ISO3} alt="" className="lg:pb-12" />
              <div className=" lg:absolute lg:top-[6rem] w-[174px]">
                <p className="text-[14px] text-[white] pt-4  text-center">
                  ISO 17100:2015{" "}
                </p>
                <p className="text-[14px] text-[#AAAAAA] text-center">
                  Translation Services Quality
                </p>
              </div>
            </li>
            <li className="logos flex flex-col items-center w-[186px]">
              <img src={ATA} alt="" className="lg:pb-12" />
              <div className="  lg:absolute lg:top-[6rem] w-[146px]">
                <p className="text-[14px] text-[white] pt-4  text-center ">
                  ATA Corporate
                </p>
                <p className="text-[14px] text-[#AAAAAA] text-center ">
                  Member Number 272444
                </p>
              </div>
            </li>
          </ul>
        </div>
      ) : (
        <div className=" px-4 flex items-center justify-center flex-col gap-y-10">
          <h2 className="text-gray text-3xl md:text-[35px] text-center font-secondary font-semibold leading-10">
            Fully <span className="text-lightBlue">Accredited</span> Translation
            Services
          </h2>
          <div className="grid gap-10 max-w-lg w-full lg:w-5/12 lg:gap-5 lg:grid-cols-2 lg:max-w-[44rem] place-items-center">
            <div>
              <img src={ata} alt="ata_corporate_number" className="w-222" />
              <p className="text-white font-opensans text-center text-sm mt-5">
                ATA Corporate Member Number 272444
              </p>
            </div>
            <div>
              <img src={iso} alt="iso_certified" />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
